export enum TRANSLATION_CONTENT_TYPE {
	SEARCH = 'search',
	EVENT = 'event',
	QUESTIONNAIRE = 'questionnaire',
}